import { useQuery } from 'react-query'
import { getOrderById } from '../..'

export default function useOrderById(id: string) {
  const { data, error, isLoading } = useQuery(
    ['order', id],
    () => getOrderById(id),
    { enabled: !!id, refetchOnWindowFocus: false }
  )
  return { data, error, isLoading }
}
